import React from 'react';
import PaymentAppliedItem from '../../../../Domain/PaymentAppliedItem';
import PaymentsAppliedService from '../../../../Services/PaymentsAppliedService';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';

export default class PaymentsAppliedTab extends React.Component {
  static defaultProps = {
    clientInvoiceId: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: { ClientInvoiceId: props.clientInvoiceId }
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={PaymentAppliedItem}
          serviceFunction={PaymentsAppliedService.GetListBySearching}
          convertDBItemsFunction={PaymentsAppliedService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderBy='ClientPaymentId'
          errorCode='PAT46'
        />
      </div>
    );
  }
}
